import { Routes } from '@angular/router';
import { HomePage } from './home-page/home-page';
import { AboutPage } from './about-page/about-page';
import { Contactpage } from './contactpage/contactpage';
import { DisclaimerPage } from './disclaimer-page/disclaimer-page';
import { TermsCondtionPage } from './terms-condtion-page/terms-condtion-page';
import { PrivacyPolicyPage } from './privacy-policy-page/privacy-policy-page';
import { CancellationPolicyPage } from './cancellation-policy-page/cancellation-policy-page';
import { Login } from './login/login';
import { Details } from './details/details';
import { VerifyEmail } from './verify-email/verify-email';
import { AuthGuard } from './guards/auth-guard';
import { Workshop } from './workshop/workshop';

export const routes: Routes = [
  {
    path: '',
    component: HomePage,
    data: {
      title: 'Learning-Portal - Your Education Hub',
      description: 'Discover Learning-Portal, your go-to platform for educational resources, courses, and tools designed to empower learners worldwide.',
      url: 'http://localhost:4200/',
      image: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png', // Use the first image from the array
    },
  },
  {
    path: 'login',
    component: Login,
    data: {
      title: 'Learning-Portal Login Page',
      description: 'Discover Learning-Portal, your go-to platform for educational resources, courses, and tools designed to empower learners worldwide.',
      url: 'http://localhost:4200/login',
      image: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png', // Use the first image from the array
    },
  },
  {
    path: 'about',
    component: AboutPage,
    data: {
      title: 'About Learning-Portal - Our Story and Mission',
      description: 'Learn about Learning-Portal’s mission to provide accessible, high-quality educational content and our vision for empowering learners globally.',
      url: 'http://localhost:4200/about',
      image: 'https://plus.unsplash.com/premium_photo-1668383778557-d71c562fdb4b?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D', // Use the first image
    },
  },
  {
    path: 'contact',
    component: Contactpage,
    data: {
      title: 'Contact Learning-Portal - Get in Touch',
      description:
        'Reach out to Learning-Portal for support, inquiries, or feedback about our educational resources and services.',
      url: 'http://localhost:4200/contact',
      image: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png', // Provide a default image
    },
  },
  {
    path: 'details',
    component: Details,
    canActivate:[AuthGuard],
    data: {
      title: 'Learning-Portal - Details',
      description:
        'Reach out to Learning-Portal for support, inquiries, or feedback about our educational resources and services.',
      url: 'http://localhost:4200/details',
      image: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png', // Provide a default image
    },
  },
  {
    path: 'workshop',
    component: Workshop,
    canActivate:[AuthGuard],
    data: {
      title: 'Learning-Portal - Workshop',
      description:
        'Reach out to Learning-Portal for support, inquiries, or feedback about our educational resources and services.',
      url: 'http://localhost:4200/workshop',
      image: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png', // Provide a default image
    },
  },
  {
    path: 'disclaimer',
    component: DisclaimerPage,
    data: {
      title: 'Learning-Portal Accessibility Statement',
      description:
        'Read Learning-Portal’s commitment to accessibility, ensuring our educational platform is inclusive for all users.',
      url: 'http://localhost:4200/disclaimer',
      image: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png', // Updated to a relevant image
    },
  },
  {
    path: 'terms-and-conditions',
    component: TermsCondtionPage,
    data: {
      title: 'Learning-Portal Terms and Conditions',
      description:
        'Review the terms and conditions for using Learning-Portal’s educational resources and services.',
      url: 'http://localhost:4200/terms-and-conditions',
      image: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
    },
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyPage,
    data: {
      title: 'Learning-Portal Privacy Policy',
      description:
        'Understand how Learning-Portal protects your personal information with our comprehensive privacy policy.',
      url: 'http://localhost:4200/privacy-policy',
      image: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
    },
  },
  {
    path: 'cancellation-policy',
    component: CancellationPolicyPage,
    data: {
      title: 'Learning-Portal Cancellation Policy',
      description: 'This page explains ChalkBasket.com Refund & Cancellation Policy',
      url: 'http://localhost:4200/cancellation-policy',
      image: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
    }
  },
  // { path: "verify-email/:id", component: VerifyEmail },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];